import * as React from 'react';

interface DebtNegExtraContextInfo {
  paymentPromiseDate?: string;
}

const DebtNegExtraContext = React.createContext({
  info: {} as DebtNegExtraContextInfo,
  setInfo: ((() => {}) as React.Dispatch<React.SetStateAction<DebtNegExtraContextInfo>>),
});

export const useDebtNegExtraContext = () => React.useContext(DebtNegExtraContext);

export const DebtNegExtraContextProvider: React.FC = ({ children }) => {
  const [ info, setInfo ] = React.useState<DebtNegExtraContextInfo>({});

  const value = React.useMemo(() => ({ info, setInfo }), [ info ]);

  return (
    <DebtNegExtraContext.Provider value={value}>
      {children}
    </DebtNegExtraContext.Provider>
  );
};
